import { inboundConstants } from '../../_constants';

export function inbound(state = {}, action) {
    switch (action.type) {
        case inboundConstants.RESET:
            return {}
        case inboundConstants.INBOUND_FETCHING:
            return {
                ...state,
                inboundFetching: true
            };
        case inboundConstants.INBOUND_FETCHED:
            return {
                ...state,
                inboundFetching: false
            };
        case inboundConstants.INBOUND_SUBMITTING:
            return {
                ...state,
                inboundSubmitting: true
            };
        case inboundConstants.INBOUND_SUBMITTED:
            return {
                ...state,
                inboundSubmitting: false
            };
        case inboundConstants.GET_VOYAGE_ARRIVALNOTICE:
            return {
                ...state,
                voyageArrivalNoticeList: action.voyageArrivalNoticeList
            }
        case inboundConstants.GET_VOYAGE_UNLOADLIST:
            return {
                ...state,
                voyageUnloadList: action.voyageUnloadList
            }
        case inboundConstants.GET_VOYAGE_UNLOADLIST_TALLYSHEET:
            return {
                ...state,
                voyageUnloadlistTallysheet: action.voyageUnloadlistTallysheet
            }
        case inboundConstants.INBOUND__GROUP_UNLOADLIST_BY_RELEASE:
            return {
                ...state,
                groupUnloadlistByRelease: action.groupUnloadlistByRelease
            }
        case inboundConstants.INBOUND_UNLOADLIST_BY_RELEASE_ID:
            return {
                ...state,
                unloadlistByreleaseId: action.unloadlistByreleaseId
            }
        case inboundConstants.INBOUND_UNLOADLIST_DATA: {
            return {
                ...state,
                unloadlistData: action.unloadlistData
            }
        }
        case inboundConstants.INBOUND_DESTINATIONS: {
            return {
                ...state,
                inboundDestinations: action.inboundDestinations
            }
        }
        case inboundConstants.INBOUND_UNLOADLIST_DATA_FOR_CREATE: {
            return {
                ...state,
                unloadlistDataForCreate: action.unloadlistDataForCreate
            }
        }
        case inboundConstants.INBOUND_TALLYSHEET_SCHEDULE: {
            return {
                ...state,
                tallySheetSchedule: action.tallySheetSchedule
            }
        }
        case inboundConstants.INBOUND_UNLOADLIST_FOR_TALLYSHEET_CREATION: {
            return {
                ...state,
                unloadlistForTallySheetCreation: action.unloadlistForTallySheetCreation
            }
        }
        case inboundConstants.INBOUND_CAN_DESTINATIONS: {
            return {
                ...state,
                canDestinations: action.canDestinations
            }
        }
        case inboundConstants.INBOUND_CARGO_ARRIVAL_NOTICE: {
            return {
                ...state,
                cargoArrivalNotice: action.cargoArrivalNotice
            }
        }
        case inboundConstants.INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING: {
            return {
                ...state,
                cargoArrivalPerBookingRef: action.cargoArrivalPerBookingRef
            }
        }
        case inboundConstants.INBOUND_CARGO_ARRIVAL_NOTICE_PERBOOKING_RESET: {
            return {
                ...state,
                cargoArrivalPerBookingRef: []
            }
        }
        case inboundConstants.INBOUND_TALLYSHEET_LIST: {
            return {
                ...state,
                tallySheetList: action.tallySheetList
            }
        }
        case inboundConstants.INBOUND_TALLYSHEET_BY_CODE: {
            return {
                ...state,
                tallySheet: action.tallySheet
            }
        }
        case inboundConstants.INBOUND_CRO: {
            return {
                ...state,
                cargoReleaseOrder: action.cargoReleaseOrder
            }
        }
        case inboundConstants.INBOUND_CRO_BY_BOOKING: {
            return {
                ...state,
                croByBooking: action.croByBooking
            }
        }
        case inboundConstants.INBOUND_CRO_BY_RELEASE_ORDER_ID: {
            return {
                ...state,
                croByReleaseOrderId: action.croByReleaseOrderId
            }
        }
        case inboundConstants.INBOUND_CDR: {
            return {
                ...state,
                cargoDeliveryReceipt: action.cargoDeliveryReceipt
            }
        }
        case inboundConstants.INBOUND_CDR_BY_BOOKING: {
            return {
                ...state,
                CDRByBooking: action.CDRByBooking
            }
        }
        case inboundConstants.INBOUND_CDR_BY_ID: {
            return {
                ...state,
                CDRById: action.CDRById
            }
        }
        case inboundConstants.INBOUND_CTS: {
            return {
                ...state,
                inboundCts: action.inboundCts
            }
        }
        case inboundConstants.INBOUND_CTS_BY_ID: {
            return {
                ...state,
                inboundCtsById: action.inboundCtsById
            }
        }
        case inboundConstants.INBOUND_CTS_BY_BOOKING: {
            return {
                ...state,
                inboundCtsByBooking: action.inboundCtsByBooking
            }
        }
        case inboundConstants.INBOUND_CTS_BY_BOOKING_TANDEM: {
            return {
                ...state,
                inboundCtsByBookingTandem: action.inboundCtsByBookingTandem
            }
        }
        case inboundConstants.GET_CONTAINER_VAN_FOR_VANIN: {
            return {
                ...state,
                containerVanForVanIn: action.containerVanForVanIn
            }
        }
        case inboundConstants.INBOUND_LOAD_VANIN_EMPTY: {
            return {
                ...state,
                inboundloadVanIn: action.inboundloadVanIn
            }
        }
        case inboundConstants.INBOUND_DEMMURAGE: {
            return {
                ...state,
                inboundDemmurage: action.inboundDemmurage
            }
        }
        case inboundConstants.INBOUND_TANDEM_DEMMURAGE: {
            return {
                ...state,
                inboundTandemDemmurage: action.inboundTandemDemmurage
            }
        }
        case inboundConstants.INBOUND_GET_VANIN_BY_ID: {
            return {
                ...state,
                inboundGetVanInById: action.inboundGetVanInById
            }
        }
        case inboundConstants.INBOUND_GET_CTS_VAN_DETAILS: {
            return {
                ...state,
                CtsVanDetails: action.CtsVanDetails
            }
        }
        case inboundConstants.INBOUND_GET_CTS_VAN_TANDEM_DETAILS: {
            return {
                ...state,
                CtsVanTandemDetails: action.CtsVanTandemDetails
            }
        }
        case inboundConstants.INBOUND_GET_CTS_DETAILS: {
            return {
                ...state,
                ctsDetails: action.ctsDetails
            }
        }
        case inboundConstants.INBOUND_GET_CTS_TANDEM_DETAILS: {
            return {
                ...state,
                ctsTandemDetails: action.ctsTandemDetails
            }
        }
        case inboundConstants.GET_VOYAGE_VESSELARRIVALNOTICE: {
            return {
                ...state,
                voyageVesselArrivalNotice: action.voyageVesselArrivalNotice
            }
        }
        case inboundConstants.INBOUND_VESSEL_ARRIVAL_NOTICE: {
            return {
                ...state,
                inboundVesselArrivalNotice: action.inboundVesselArrivalNotice
            }
        }
        case inboundConstants.GET_VOYAGE_CROCLEARANCE: {
            return {
                ...state,
                getVoyageCroClearance: action.getVoyageCroClearance
            }
        }
        case inboundConstants.INBOUND_GET_CROCLEARANCE: {
            return {
                ...state,
                getCroClearance: action.getCroClearance
            }
        }
        case inboundConstants.INBOUND_GET_CROUNPAIDWB: {
            return {
                ...state,
                CroUnpaidWaybills: action.CroUnpaidWaybills
            }
        }
        case inboundConstants.GET_DISPATCH_LIST:
            return {
                ...state,
                DispatchList: action.DispatchList
            };
        case inboundConstants.GET_ARCHIVE_DISPATCH_LIST:
            return {
                ...state,
                ArchiveDispatchList: action.ArchiveDispatchList
            };
        case inboundConstants.INBOUND_DWELL_TIME:
            return {
                ...state,
                InboundDwellTime: action.InboundDwellTime
            };
        case inboundConstants.CONSIGNEE_EMAIL:
            return {
                ...state,
                ConsigneeEmail: action.ConsigneeEmail
            };
        default:
            return state;
    }
}